import React from 'react'
import InfoIcon from '@mui/icons-material/Info';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import * as S from './styles'

interface IButtonDetailsPartProps {
  showLabel?: boolean;
  guidSupplierInventory?: string | null;
  notQuote?: boolean;
  handleOpenModalDetails: (guidPart: string) => void;
}
function ButtonDetailsPart({
  showLabel = false,
  guidSupplierInventory,
  notQuote,
  handleOpenModalDetails
}: IButtonDetailsPartProps) {

  if (isNullUndefined(guidSupplierInventory) || notQuote) return null

  return (
    <S.ButtonInfo
      aria-label="info"
      size="small"
      title={getTranslateByKey('information.partDetails')}
      onClick={() => handleOpenModalDetails(String(guidSupplierInventory))}
    >
      <InfoIcon />
      {showLabel && <S.Label>{getTranslateByKey('information.partDetails')}</S.Label>}
    </S.ButtonInfo>

  )
}

export default ButtonDetailsPart